import { forwardRef } from 'react';

import { ActionIcon, ActionIconProps, Box, Indicator, IndicatorProps } from '@mantine/core';
import { IconShoppingCart } from 'ui-icons';

interface CartActionIconProps {
  onClick?: () => void;
  count?: number;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  actionIconProps?: ActionIconProps;
  indicatorProps?: IndicatorProps;
  className?: string;
}

const CartActionIcon = forwardRef<HTMLDivElement, CartActionIconProps>(
  ({ onClick, count = 0, actionIconProps, indicatorProps, className, ...props }, ref) => (
    <Box {...props} ref={ref} className={className}>
      <Indicator
        withBorder
        size={25}
        fw={600}
        fz={10}
        disabled={!count}
        label={count}
        color="cobalt"
        {...indicatorProps}
      >
        <ActionIcon size="md" variant="gray" onClick={onClick} {...actionIconProps}>
          <IconShoppingCart />
        </ActionIcon>
      </Indicator>
    </Box>
  )
);

CartActionIcon.displayName = 'CartActionIcon';
export { CartActionIcon };
